import { GlobalSettings } from 'src/app/lib/global-settings';
import { Money } from 'src/app/lib/money/money';

export class FreePurchasedProductInformation {
  id: number;
  name: string;
  price: Money;
  quantity: number;

  static createFromAny(data: any): FreePurchasedProductInformation {
    const freePurchasedProductInformation = new FreePurchasedProductInformation();
    if (data) {
      freePurchasedProductInformation.name = data.product_name || '';
      freePurchasedProductInformation.price = data.price != null ? new Money(data.price, GlobalSettings.getCurrencyCode()) : Money.empty;

      freePurchasedProductInformation.id = data.product_id || 0;
      freePurchasedProductInformation.quantity = data.quantity || 0;
    }

    return freePurchasedProductInformation;
  }

  static createFromAnyArray(array: any): FreePurchasedProductInformation[] {
    if (!array) {
      return [];
    }
    return array.map(this.createFromAny).filter(item => item != null);
  }

  get totalAmount(): Money {
    return new Money(this.price.value * this.quantity, this.price.currencyCode);
  }
}
